import { memo } from "react";
import { Bubble } from "./Bubble";

export { TransformedStatusBubble };
const TransformedStatusBubble = memo(() => {
  return (
    <Bubble className={"gray"} text={"Transformed"} style={{ marginLeft: 5 }} />
  );
});
